/* ============================================================================
 * constants.ts - Shared constants for ProjectDataContext
 * ============================================================================ */

import { WS_ENDPOINT } from '@/shared/apiClient';
import type { GlobalUIState, ViewStates } from '@/shared/types/applicationState';

export const WS_URL = WS_ENDPOINT;

// View states and UI state placeholders (not needed in current implementation)
export const viewStates: ViewStates | null = null;
export const uiState: GlobalUIState | null = null;
